var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.771 3.022a.5.5 0 0 1 .707 0l5.626 5.625a.5.5 0 0 1 0 .707l-5.625 5.625a.5.5 0 0 1-.708-.707L14.543 9.5H2.25a.5.5 0 0 1 0-1h12.293L9.771 3.73a.5.5 0 0 1 0-.707"
  })));
};
export default SvgArrowRight;